import { Flex, Text } from '@chakra-ui/react';
import { DisbursementDataType } from 'pages/Payment';
import React from 'react';

interface UploadFileInputProps {
    disbursementData: DisbursementDataType;
    isHasFiles: boolean;
    isDragActive?: boolean;
}

const UploadFileInput = (
    { disbursementData, isHasFiles, isDragActive }: UploadFileInputProps
) => {
    return (
        <Flex
            {...disbursementData.rootProps()}
            textAlign="center"
            h="135px"
            flexDir="column"
            borderRadius="5px"
            borderWidth={1}
            borderColor={isDragActive ? "blue.500" : "#C6C6C6"}
            borderStyle="dashed"
            fontWeight="500"
            fontSize="12px"
            justifyContent="center"
            alignItems="center"
            onClick={disbursementData.open}
            cursor={isHasFiles ? "not-allowed" : "pointer"}
        >
            <Text color={!isHasFiles ? "blue.500" : "#C6C6C6"} p="10px">
                Drag and drop files here or click to upload
            </Text>
            <input
                {...disbursementData.inputProps()}
                disabled={isHasFiles}
                data-testid={`${disbursementData.key}-input-upload`}
            />
        </Flex>
    );
};

export default UploadFileInput;